import * as React from "react";
import { App } from "./app"

interface QReportTabGWVm {
    app: App
    buttonID: string
}

// ExtTabGW is a toggle button that either shows or hides the extended info window to the right
export class QReportTabGW extends React.Component<QReportTabGWVm, { hoverState: boolean }> {
    constructor(props: QReportTabGWVm) {
        super(props)
    }
    
    state = {
        hoverState: false
    }

    // Sets the core's reference back to this tab on initiation 
    componentWillMount() {
        this.props.app.GetCore().ConnectQReportTab(this)
    }

    // Mouse click events trigger the toggle method
    onClick() {
        this.props.app.GetCore().ClearSelection()
        this.setState({ hoverState: false })
        this.props.app.setArticlesPageSelection()
        this.props.app.ScrollToTop()
    }
        
    // Mouse out events affecting the graphics through the hoverstate
    mouseOutHandler(e: React.MouseEvent<HTMLImageElement>) {
        this.setState({ hoverState: false })
    }

    // Mouse over events affecting the graphics through the hoverstate
    mouseOverHandler(e: React.MouseEvent<HTMLImageElement>) {
        if (this.props.app.state.DisplayMode != this.props.app.DMode.QReport) {
            this.setState({ hoverState: true })
        }
    }

    // Renders the ext. info toggle button
    render() {
        const imageFileName = "url(images/QReportArrowIcons.png)"

        // Positioning the image offset, showing different parts depending on states
        var offset = 0

        if (this.state.hoverState == false) {
            offset += 34
        }

        // turns the offset into a string that will be used to position the background image
        const bgPosition = "0px -" + offset.toString() + "px"

        var textColor = (this.state.hoverState == true) ? "#e5f1ff" : "#d0e0f0"

        var returnValue = <div></div>

        var selectedBuildParts = this.props.app.GetCore().GetSelectedBuildParts()
        var hasBuildparts = false
        
        if (selectedBuildParts != null) {
            if (selectedBuildParts.length > 0) {
                hasBuildparts = true
            }
        }

        if (hasBuildparts == false) {
            // If no items are selected, no quickreport will be available to be shown
            var selection = this.props.app.GetCore().GetSelectedArticles()
            if (selection == null) {
                return <div>
                </div>
            }
            else {
                if (selection.length == 0) {
                    return <div>
                    </div>
                }
            }
        }
        
        if (this.props.app.state.DisplayMode == this.props.app.DMode.QReport) {
            // Qreport is allready being shown, so no need for any button to show it
            return <div>
            </div>
        }
        else {
            return <div style={{ display: "flex", flexDirection: "row", width: "153px", height: "34px" }}>
                <div
                    onClick={this.onClick.bind(this)}
                    onMouseOut={this.mouseOutHandler.bind(this)}
                    onMouseOver={this.mouseOverHandler.bind(this)}
                    style={{ cursor: "pointer", width: "53px", height: "34px", backgroundImage: imageFileName, backgroundPosition: bgPosition }} >
                </div>
                <div
                    onClick={this.onClick.bind(this)}
                    onMouseOut={this.mouseOutHandler.bind(this)}
                    onMouseOver={this.mouseOverHandler.bind(this)}
                    style={{ backgroundColor: "#4b6078", height: "100%", width: "100px" }} >
                    <div style={{ height: "24px", position: "relative", top: "7px", left: "0px", color: textColor, backgroundColor: "#4b6078", fontSize: "16px" }}>Vis Utvalg</div>
                </div>
            </div>
        }
    }
}


// WEBPACK FOOTER //
// ./client/view/QReportTabGW.tsx